var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcnShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 14.3336C12.1046 14.3336 13.0001 13.4381 13.0001 12.3335C13.0001 11.2289 12.1046 10.3335 11 10.3335C9.89545 10.3335 9 11.2289 9 12.3335C9 13.4381 9.89545 14.3336 11 14.3336Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.00005 9.66709C4.10464 9.66709 5.00009 8.77163 5.00009 7.66704C5.00009 6.56244 4.10464 5.66699 3.00005 5.66699C1.89545 5.66699 1 6.56244 1 7.66704C1 8.77163 1.89545 9.66709 3.00005 9.66709Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.72656 8.67334L9.28 11.3267",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11 5.00009C12.1046 5.00009 13.0001 4.10464 13.0001 3.00005C13.0001 1.89545 12.1046 1 11 1C9.89545 1 9 1.89545 9 3.00005C9 4.10464 9.89545 5.00009 11 5.00009Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.27333 4.00684L4.72656 6.66023",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnShare);
export default __webpack_public_path__ + "static/media/icn-share.4fcaf6969e2289299dac7c98819fb98c.svg";
export { ForwardRef as ReactComponent };